import React from 'react';
import {
  TopNav,
  Logo,
  SearchBar,
  ShoppingCart,
  UserNav,
  BreadCrumb,
  HotLine,
  DownloadApp
} from './sub-header';
import {connect} from 'react-redux';
import {setDataBreadCrumb} from 'actions';
import {Link} from 'react-router-dom';
import {ShowIf} from 'components/utils';
import {logout} from 'base/actions';
import {toastr} from 'react-redux-toastr';
import './sub-header/_UserLogin.scss';

class Header extends React.Component {
  constructor(props, context){
    super(props, context);
    this.state = {
      opened: false,
      scrollTop: '',
      dataBreadcrumb: this.props.dataBreadcrumb,
      hasBreadcrumb: false
    };
    this.props.dispatch(setDataBreadCrumb(false, []));

    this.signout = this.signout.bind(this);
  }

  signout() {
    this.props.dispatch(logout()).then(res => {
      // go home
      toastr.success("Thành công", "Bạn đã đăng xuất thành công");
      this.props.history.push('/');
    })
  }

  componentDidMount() {
    this.setState({
      hasBreadcrumb: this.props.hasBreadcrumb,
      dataBreadcrumb: this.props.dataBreadcrumb
    })
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.dataBreadcrumb != nextProps.dataBreadcrumb) {
      this.setState({
        hasBreadcrumb: nextProps.hasBreadcrumb,
        dataBreadcrumb: nextProps.dataBreadcrumb
      });
    }
  }

  openMenu() {
    this.setState({
      scrollTop: window.scrollY
    })
    this.setState({opened: true});
    setTimeout(function(){
      let style = 'position: fixed; width: 100%; minHeight: 100mvh'
      document.getElementById('root').setAttribute("style", style);
    }, 400);
  }

  closeMenu() {
    document.getElementById('root').setAttribute("style", "");
    window.scrollTo(0, this.state.scrollTop);
    this.setState({opened: false});
  }

  toogleSearch() {
    let Search = document.getElementById('searchMobile');
    let userMenu = document.getElementById('userMenu');
    let userImage = document.getElementById('userImage');
    document.body.classList.remove('open');
    Search.classList.toggle('open');
    userMenu.classList.remove('open');
    userImage.classList.remove('open');
  }

  render() {
    return (
      <div className={'header ' + `${this.state.opened ? 'menu-open' : ''}`} id='header'>
        <TopNav isActive={this.props.isActive}/>
        <div className={'wrap-container ' + `${this.state.opened ? 'menu-open' : ''}`}>
          <div className='center'>
            <div className='wrap-nav-top'>
              <Logo/>
              <SearchBar/>
              {/* <div className='hide-mobile'>
                <DownloadApp/>
              </div> */}
              <div className='hide-mobile'>
                <ShoppingCart/>
              </div>
              <ul className='user-top-nav-list hide-mobile'>
                <li className='nav-item'>
                  <ShowIf condition={!this.props.auth.isAuthenticated}>
                    <Link to='/signin' className='user-link'>Đăng nhập</Link>
                  </ShowIf>
                  <ShowIf condition={this.props.auth.isAuthenticated}>
                    <Link to='/dashboard' className='user-link'>Tài khoản của tôi</Link>
                  </ShowIf>
                </li>
                <li>&nbsp;/&nbsp;</li>
                <li className="nav-item">
                  <ShowIf condition={!this.props.auth.isAuthenticated}>
                    <Link to='/signup' className='user-link'>Đăng ký</Link>
                  </ShowIf>
                  <ShowIf condition={this.props.auth.isAuthenticated}>
                    <a href='javascript:void(0)' className='user-link' onClick={this.signout}>Đăng xuất</a>
                  </ShowIf>
                </li>
              </ul>
              <div className='content-show-mobile'>
                <button className='btn-search-mobile' onClick={this.toogleSearch.bind(this)}><span className='vtd-search'></span></button>
                <SearchBar id='searchMobile'/>
                <ShoppingCart/>
                <UserNav/>
              </div>
            </div>
          </div>
        </div>
        {
          this.state.hasBreadcrumb == true ? (
            <BreadCrumb data={this.state.dataBreadcrumb} classBreadcrumb={this.props.classBreadcrumb}/>
          ) : null
        }
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    hasBreadcrumb: state.breadcrumb.hasBreadcrumb,
    dataBreadcrumb: state.breadcrumb.data,
    auth: state.auth
  };
};

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./components/layouts/master/Header.jsx